import { IPG } from "@/types/summary";

export const formatTextsWithTran = (pg: IPG[], transPg: IPG[]) => {
  if (!pg && !transPg) return [];
  // 同时有原文和翻译/只有原文
  if (pg.length) {
    return pg.map((item) => {
      const transItem = transPg.find(
        (transPgItem) =>
          transPgItem.sc[0].bt === item.sc[0].bt &&
          transPgItem.sc[0].et === item.sc[0].et
      );
      return {
        ...item,
        sc: item.sc.map((sItem, sIndex) => {
          if (transItem && transItem.sc && transItem.sc[sIndex]) {
            sItem.transTc = transItem.sc[sIndex].tc;
          } else {
            sItem.transTc = "";
          }
          return sItem;
        }),
      };
    });
  }
  // 只有翻译
  return transPg.map((item) => {
    return {
      ...item,
      sc: item.sc.map((sItem) => {
        sItem.transTc = sItem.tc;
        sItem.tc = "";
        return sItem;
      }),
    };
  });
};
